module.exports = __webpack_public_path__ + "img/icon_t6.2fd0219f.png";